var _path, _ellipse, _ellipse2, _path2, _path3, _path4, _path5, _rect, _g, _g2, _g3, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup2540(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2540",
    "data-name": "Group 2540",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.29,
    height: 70.775,
    viewBox: "0 0 109.29 70.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6584",
    "data-name": "Path 6584",
    d: "M335.9,210.895c-4.856-.075-5.7,0-8.43,0H305V187.5l11.913,1.39C319.094,188.89,321.175,190.227,335.9,210.895Z",
    transform: "translate(-230.414 -168.491)",
    fill: "#b3b3ff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 9.027,
    cy: 8.526,
    rx: 9.027,
    ry: 8.526,
    transform: "translate(26.064 50.765)",
    fill: "#b3b3ff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 9.027,
    cy: 8.526,
    rx: 9.027,
    ry: 8.526,
    transform: "translate(81.453 50.765)",
    fill: "#b3b3ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6580",
    "data-name": "Path 6580",
    d: "M84.4,267.305a9.447,9.447,0,1,0,2.771,6.68,9.387,9.387,0,0,0-2.771-6.68m-1.533,11.827A7.279,7.279,0,1,1,85,273.986a7.232,7.232,0,0,1-2.135,5.147",
    transform: "translate(-44.25 -212.662)",
    fill: "#3335cf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6581",
    "data-name": "Path 6581",
    d: "M367.851,264.534a9.451,9.451,0,1,0,9.451,9.452,9.462,9.462,0,0,0-9.451-9.452m0,16.733a7.281,7.281,0,1,1,7.281-7.281,7.29,7.29,0,0,1-7.281,7.281",
    transform: "translate(-278.053 -212.662)",
    fill: "#3335cf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6582",
    "data-name": "Path 6582",
    d: "M83.341,46.236a1.072,1.072,0,0,0-.905-.493H65.248V35.209a1.077,1.077,0,0,0-1.077-1.075H1.077A1.077,1.077,0,0,0,0,35.209V88.278a1.077,1.077,0,0,0,1.077,1.075h12.7V87.2H2.153V82.72h8.3V80.569h-8.3V36.285H63.095v4.483H6.641v2.151H63.095V80.569H34.868V82.72H63.095V87.2H31.547v2.151H70.229V87.2H65.248V47.894h16.6l.172.268,2.135,3.317.578.9H70.813a1.077,1.077,0,0,0-1.077,1.075V68.377a1.077,1.077,0,0,0,1.077,1.075h24.91l.172.268.314.488.093.144V80.569H91.321V82.72H96.3V87.2H88v2.151h9.379a1.077,1.077,0,0,0,1.077-1.075V70.036a1.063,1.063,0,0,0-.17-.581ZM93.27,67.3H71.889V54.527H85.173V53.06l1.075,1.67L93.761,66.4l.578.9Z",
    transform: "translate(10.834 -26.945)",
    fill: "#3335cf"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6583",
    "data-name": "Path 6583",
    d: "M356.718,214.789a1.669,1.669,0,0,1-.288-.386,1.669,1.669,0,0,0,.288.386",
    transform: "translate(-276.267 -172.163)",
    fill: "#3335cf"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17755",
    "data-name": "Rectangle 17755",
    width: 22.25,
    height: 2.17,
    transform: "translate(17.375 1.142)",
    fill: "#ff7b00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2537",
    "data-name": "Group 2537",
    transform: "translate(9.248 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M207.9,27.008a2.2,2.2,0,1,1,2.2-2.2A2.2,2.2,0,0,1,207.9,27.008Zm0-2.731a.535.535,0,1,0,.535.536A.536.536,0,0,0,207.9,24.277Z",
    transform: "translate(-205.701 -22.617)",
    fill: "#ff7b00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2538",
    "data-name": "Group 2538",
    transform: "translate(62.293 65.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M315.5,115.821a.827.827,0,0,1-.587-.243l-1.874-1.874a.83.83,0,0,1,0-1.174l1.874-1.874a.83.83,0,0,1,1.174,0l1.874,1.874a.83.83,0,0,1,0,1.174l-1.874,1.874A.827.827,0,0,1,315.5,115.821Zm-.7-2.7.7.7.7-.7-.7-.7Z",
    transform: "translate(-312.792 -110.412)",
    fill: "#c5c5ff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2539",
    "data-name": "Group 2539",
    transform: "translate(82.032 11.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M45.12,323.057a.83.83,0,0,1-.587-.243l-1.874-1.874a.83.83,0,0,1,0-1.174l1.874-1.874a.83.83,0,0,1,1.174,0l1.874,1.874a.83.83,0,0,1,0,1.174l-1.874,1.875A.83.83,0,0,1,45.12,323.057Zm-.7-2.7.7.7.7-.7-.7-.7Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#6583fe"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6588",
    "data-name": "Path 6588",
    d: "M19.787,140.5a1.377,1.377,0,0,0,1.377-1.377v-1.377h1.377a1.377,1.377,0,1,0,0-2.754H21.164v-1.377a1.377,1.377,0,1,0-2.754,0v1.377H17.033a1.377,1.377,0,1,0,0,2.754H18.41v1.377A1.377,1.377,0,0,0,19.787,140.5Z",
    transform: "translate(-15.656 -79.357)",
    fill: "#ff7b00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2540);
export default __webpack_public_path__ + "static/media/Group 2540.112669a4f03b7113c3e7318a5eb1c8dc.svg";
export { ForwardRef as ReactComponent };